<script>
export default {
	inserted(el, bindings, vnode) {
		el.addEventListener('click', () => {
			vnode.context.$root.$emit('dialog-close', bindings.value);
		});
	},
};
</script>
